import React, { Component } from 'react';

import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

class ContactInfo extends Component {

  render() {
    return (
      <div>
        <Typography component="h3" align={this.props.itemAlign} variant="body2">
          Adresa:
        </Typography>
        <Typography component="h3" align={this.props.itemAlign} variant="subheading">
          <Button size='small'>Joa Lajoša 4a, 24000 SUBOTICA</Button>
        </Typography>
        <Typography component="h3" align={this.props.itemAlign} variant="body2">
          Telefon za zakazivanje:
        </Typography>
        <Typography component="h3" align={this.props.itemAlign} variant="subheading">
          <Button size='small'><a href='tel:+38124520698'>+381(24) 520-698</a></Button>
          <Button size='small'><a href='tel:+381665232899'>+381(66) 52-32-899</a></Button>
        </Typography>
        <Typography component="h3" align={this.props.itemAlign} variant="body2">
          eMail:
        </Typography>
        <Typography component="h3" align={this.props.itemAlign} variant="subheading">
          <Button size='small'><a href='mailTo:sente@ptt.rs'>sente@ptt.rs</a></Button>
        </Typography>
      </div>
    )
  }
}

export default ContactInfo;



// WEBPACK FOOTER //
// ./src/components/ContactInfo.js